import React from 'react';

// To pass information about the game being played so that it can be displayed in the required place, such as score, number of lives, etc.
export const GameContext = React.createContext(undefined);
